import React from 'react'
import { MotionDiv, MotionImage, MotionSection } from '../motion/Motion'

export default function AboutUsHero() {
  return (
    <MotionSection className="w-full py-12 lg:py-16">
      <div className="grid gap-10 lg:grid-cols-2 items-center">
        <MotionDiv className="w-[96%] mx-auto lg:mx-0 lg:ml-[2%] pl-0 sm:pl-3 md:pl-5 lg:pl-[30px] space-y-4" delay={0.02}>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">Our Story</h1>
          <p className="text-sm sm:text-base text-gray-700 leading-relaxed max-w-xl">
            Logo Branded Door Mats Zambia was established with a singular mission: to provide Zambian businesses,
            institutions, and retailers with access to world-class, durable, custom-branded matting solutions without
            the headaches of international procurement. We understand that in a high-traffic environment like Lusaka,
            Ndola, or Kitwe, a generic mat simply won't last.
          </p>
        </MotionDiv>

        <MotionImage className="w-full lg:pl-6" delay={0.08}>
          <div className="w-full h-64 sm:h-80 lg:h-[440px] overflow-hidden bg-gray-100 lg:-mt-6">
            <img
              src="/images/sectionimages/abouthero.png"
              alt="About hero"
              className="w-full h-full object-cover"
            />
          </div>
        </MotionImage>
      </div>
    </MotionSection>
  )
}
